module.exports = __webpack_public_path__ + "img/room-design-competition_arzh.31bcff6a.png";